import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../../themes/default';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 1.5
  }
});

const TabContent = ({children, classes}) => {
  return (
    <div className={ classNames( "Content-Tab", classes.root )}>
      { children }
    </div>
  )
}

TabContent.propTypes = {
  children: PropTypes.node.isRequired
};

export default withStyles(styles)(TabContent);
